import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorTracking } from '@lima/error-tracking-react';
import App from './output';
import registerServiceWorker from './registerServiceWorker';
import './component/common/common.less';
import { install } from '@lima/seraphim-react';
ErrorTracking('saas-pc');
install();
//Sentry.init({
//    dsn: process.env.SENTRY_DSN,
//    // dsn: 'https://bda7f959977e48afb03ccbf5a2b56a44@e-tracking.zhongbaounion.com/22',
//    ignoreErrors: [
//        /[\S\s]*7moorInit.js/, // 七陌客服组件抛出的异常暂不上报
//        /Non-Error promise rejection captured with keys: errors, values/i, // 表单验证不用上报
//        /Can't find variable: DragEvent/i, // safari 12.1.1版本特定问题 且不会产生错误 忽略即可
//        /(Cannot read property 'x' of undefined).*(removeMoveHandler)/i, // 忽略 antd drawer报错 https://github.com/ant-design/ant-design/issues/25870
//    ],
//    integrations: [new Integrations.BrowserTracing()],
//    allowUrls: [/.+\.zhongbaounion\.com/],
//    release: `商户平台@${process.env.SENTRY_RELEASE || ''}`,
//    enabled: envHandler.isProd(),
//    environment: envHandler.getEnv(),
//    maxBreadcrumbs: 50,
//    tracesSampleRate: 0.1,
//    sampleRate: 0.1,
//    attachStacktrace: true,
//    initialScope: scope => {
//        scope.setTags({ 'environment': envHandler.getEnv() });
//        return scope;
//    },
//    beforeSend(event, hint) {
//        try {
//            const exceptionStr = JSON.stringify(_.at(event, 'exception.values') || '[]');
//            const errorStr = String(hint.originalException || '').toString();
//
//            const isInternalError = [
//                /Non-Error promise rejection captured with keys: config, data, headers, request, status/i,
//                /Request failed with status code/i
//            ].some((reg) => reg.test(exceptionStr) || reg.test(errorStr));
//
//            if (isInternalError) {
//                event.tags = { ...event.tags, errorType: 'internal errors' }; // 后端接口错误打上 “internal errors”标签
//            }
//        } catch (e) {}
//
//        return event;
//    },
//});

ReactDOM.render(<App/>, document.getElementById('root'));
registerServiceWorker();
